export const useLivekitSpectators = () => ({
  peers: [],
  loadPeers: Promise.resolve(),
  loadMorePeers: Promise.resolve(),
  hasNext: true,
  total: 0,
});
